import React, { useState, useEffect } from 'react'
import "./index.css";
import { Route, Switch } from 'react-router-dom';

const Page = ({ children }) => {
    const [collapsed, setCollapsed] = useState(true);
    const [headerIsTop, setHeaderIsTop] = useState(true);

    /**
     * Collapse header when app
     */
    const toggleNavbar = () => {
        setCollapsed && setCollapsed(!collapsed);
    };

    /**
     * Creates a moviment when user scroll to top. 
     */
    const listenScrollEvent = (event) => {
        if (window.scrollY < 73) {
            setHeaderIsTop && setHeaderIsTop(true);
        } else {
            setHeaderIsTop && setHeaderIsTop(false);
        }
    }
    /**
     * Listen scroll event when scroll full top
     */
    useEffect(() => {
        window.addEventListener('scroll', listenScrollEvent);

        return () =>
            window.removeEventListener('scroll', listenScrollEvent);
    }, []);
    return (
        <div className="Page">
            <header className="header-page">
                <div className={"container-fluid Page__webMenu" + (headerIsTop ? "-dellocated" : "")}>
                    <div>
                        <a href="https://www.pandhora.com/">
                            <img
                                src="http://pandhora.mz-sites.com/wp-content/uploads/sites/611/2021/04/logo-sticky.png"
                                alt="Pandhora Fundo"
                            />
                        </a>
                        <a href="https://www.pandhora.com" className="logo logo--sticky" hidden>
                            <img src="https://www.pandhora.com/wp-content/uploads/sites/611/2021/04/logo-sticky.png" alt="Pandhora Fundo" />
                        </a>
                    </div>

                    <nav className="nav navbar_block" >
                        <ul className="mb-2 mb-lg-0 Page__headerNav">
                            <li className="Page__headerNavItem">
                                <a className="Page__headerNavItemLink" aria-current="page" href="https://www.pandhora.com/">
                                    Home</a>
                            </li>
                            <li className=" Page__headerNavItem">
                                <a className="Page__headerNavItemLink" aria-current="page" href="https://www.pandhora.com/quem-somos/">
                                    Quem somos</a>
                            </li>
                            <li className="Page__headerNavItem dropdown">
                                <a className="Page__headerNavItemLink" aria-current="page">
                                    Fundos</a>
                                <ul className="dropdown-content" >
                                    <li href="https://www.pandhora.com/essencial/">
                                        <a href="https://www.pandhora.com/essencial/">Essencial</a>
                                    </li>
                                    <li style={{ borderBottomRightRadius: "24px" }} href="https://www.pandhora.com/long-bias/">
                                        <a href="https://www.pandhora.com/long-bias/">Long Bias</a>
                                    </li>
                                </ul>
                            </li>
                            <li className="Page__headerNavItem Page__headerNavItem--active">
                                <a className="Page__headerNavItemLink" aria-current="page" href="http://simulador.pandhora.com">
                                    Simulador</a>
                            </li>
                            <li className="Page__headerNavItem">
                                <a className="Page__headerNavItemLink" aria-current="page" href="https://blog.pandhora.com/">
                                    Blog</a>
                            </li>
                        </ul>
                    </nav>
                    <div className="Page__MenuApp" onClick={toggleNavbar}>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div className="header__login_quero_investir">
                        <a className="Page_login" href="https://investindobem.com/app/#/signin" target="_blank">Login</a>
                        <a href="https://www.pandhora.com/quero-investir/" className="button">Quero Investir</a>
                    </div>
                </div>

                <div className={collapsed ? "collapse" : "" + " header__AppMenu" + (headerIsTop ? "-dellocated" : "")}>
                    <ul><li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-2 current_page_item menu-item-122"><a href="https://www.pandhora.com/" aria-current="page">Home</a></li>
                        <li className="header__AppMenuItem"><a href="https://www.pandhora.com/quem-somos/">Quem somos</a></li>
                        <li className="header__AppMenuItem"><a>Fundos</a>
                            <ul className="sub-menu">
                                <li className="header__AppMenuSubItem"><a href="https://www.pandhora.com/essencial/">Essencial</a></li>
                                <li className="header__AppMenuSubItem"><a href="https://www.pandhora.com/long-bias/">Long Bias</a></li>
                            </ul>
                        </li>
                        <li className="header__AppMenuItem"><a href="http://simulador.pandhora.com">Simulador</a></li>
                        <li className="header__AppMenuItem"><a target="_blank" rel="noopener" href="https://blog.pandhora.com/">Blog</a></li>
                    </ul>
                    <div className="header__login_quero_investirApp">
                        <a className="Page_login" href="https://investindobem.com/app/#/signin" target="_blank">Login</a>
                        <a href="https://www.pandhora.com/quero-investir/" className="button">Quero Investir</a>
                    </div>
                </div>
            </header>
            {children}
            <footer className="Page__footer">
                <div className="container">
                    <div className="Page__footertop d-flex align-items-center justify-content-between">
                        <a href="http://pandhora.mz-sites.com">
                            <img
                                src="http://pandhora.mz-sites.com/wp-content/uploads/sites/611/2021/04/pandhora-logo-white.png"
                                alt="Pandhora Fundo"
                            />
                        </a>
                        <ul className="Page__footertopSocialMedia d-flex">
                            <li className="item">
                                <a href="https://www.youtube.com/c/PandhoraInvestimentos">
                                    <img
                                        src="http://pandhora.mz-sites.com/wp-content/themes/mziq_pandhora/img/social-media/icon-youtube.png"
                                        alt="youtube"
                                    />
                                </a>
                            </li>
                            <li className="item">
                                <a href="https://www.linkedin.com/company/pandhora-investimentos">
                                    <img
                                        src="http://pandhora.mz-sites.com/wp-content/themes/mziq_pandhora/img/social-media/icon-linkedin.png"
                                        alt="linkedin"
                                    />
                                </a>
                            </li>
                            <li className="item">
                                <a href="https://www.instagram.com/pandhora.investimentos/">
                                    <img
                                        src="http://pandhora.mz-sites.com/wp-content/themes/mziq_pandhora/img/social-media/icon-instagram.png"
                                        alt="instagram"
                                    />
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="Page__footerLinks">
                        <ul>
                            <li>
                                <a className="first">SAIBA MAIS</a>
                                <a href="http://pandhora.mz-sites.com/" target="_blank">Home</a>
                                <a href="http://pandhora.mz-sites.com/quem-somos/" target="_blank">Quem somos</a>
                                <a href="https://simulador.pandhora.com/#/" target="_blank">Simulador</a>
                                <a href="https://blog.pandhora.com/" target="_blank">Blog</a>
                            </li>
                            <li>
                                <a className="first">FUNDOS</a>
                                <a href="http://pandhora.mz-sites.com/essencial/" target="_blank">Essencial</a>
                                <a href="http://pandhora.mz-sites.com/long-bias/" target="_blank">Long Bias</a>
                                <a href="https://api.mziq.com/mzfilemanager/v2/d/1da50f6b-2bca-45ed-8306-cd619c5d6cfc/0312de0b-f390-8518-ac0b-b964b0a791e8?origin=2" target="_blank">Material de divulgação Essencial</a>
                                <a href="https://api.mziq.com/mzfilemanager/v2/d/1da50f6b-2bca-45ed-8306-cd619c5d6cfc/c4b21a20-33a2-35b1-9545-0b895c8996a9?origin=2" target="_blank">Material de divulgação Long Bias</a>
                            </li>
                            <li>
                                <a className="first">DOCUMENTOS</a>
                                <a href="https://api.mziq.com/mzfilemanager/v2/d/1da50f6b-2bca-45ed-8306-cd619c5d6cfc/0813ce9b-81fa-fcf3-f167-c620ff0c9bd9?origin=2" target="_blank">Código de ética</a>
                                <a href="https://api.mziq.com/mzfilemanager/v2/d/1da50f6b-2bca-45ed-8306-cd619c5d6cfc/1755be07-ed9c-a12f-9b4a-39ea4fc45b28?origin=2" target="_blank">Formulário de referência</a>
                                <a href="https://api.mziq.com/mzfilemanager/v2/d/1da50f6b-2bca-45ed-8306-cd619c5d6cfc/248116c4-05dc-cd36-6448-082bca6ce7a7?origin=2" target="_blank">Manual de compliance</a>
                                <a href="https://api.mziq.com/mzfilemanager/v2/d/1da50f6b-2bca-45ed-8306-cd619c5d6cfc/1c5d24e1-5cb3-609a-dd51-16c579aa9030?origin=2" target="_blank">Política de gestão de risco</a>
                                <a href="https://api.mziq.com/mzfilemanager/v2/d/1da50f6b-2bca-45ed-8306-cd619c5d6cfc/6fabf41d-deba-3cf0-e375-62cf7ceffb5d?origin=2" target="_blank">Política de investimento pessoal</a>
                                <a href="https://api.mziq.com/mzfilemanager/v2/d/1da50f6b-2bca-45ed-8306-cd619c5d6cfc/3048cbee-79f7-06dd-7190-47acd3a97d27?origin=2" target="_blank">Política de rateio e divisão de ordens</a>
                                <a href="https://api.mziq.com/mzfilemanager/v2/d/1da50f6b-2bca-45ed-8306-cd619c5d6cfc/fbcc3735-c105-d684-352c-11838c7e0185?origin=2" target="_blank">Políticas de privacidade</a>


                            </li>
                            <li>
                                <a className="first">Fale Conosco</a>
                                <p>
                                    <a>dpo@pandhora.com</a>
                                </p>
                                <p>
                                    <a>contato@pandhora.com</a>
                                </p>
                                <p>
                                    <a>
                                        Rua Viradouro, 63, cj.51 – Itaim
                                        <br />
                                        São Paulo – CEP 04538-110</a>
                                </p>
                            </li>
                            <li className="AnbimaIcon">
                                <img
                                    src="https://www.pandhora.com/wp-content/uploads/sites/611/2021/08/Selo-ANBIMA-site-1.png"
                                    alt=""
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="Page__footerPrivacy">
                        <p>
                            A Pandhora Investimentos Ltda.(“Pandhora”) é uma gestora de
                            recursos devidamente credenciada na Comissão de Valores
                            Mobiliários - CVM como administradora de carteira, de acordo com o
                            Ato Declaratório CVM n.º 17.517 e constituída sob os moldes da
                            Instrução CVM Nº558/15. A gestora é aderente ao códigos ANBIMA de
                            Regulação e Melhores Práticas para Administração de Recursos de
                            Terceiros e código ANBIMA de Regulação e Melhores Práticas para o
                            Programa de Certificação Continuada. A Pandhora não comercializa
                            ou distribui quotas de fundos de investimento, portanto todas as
                            informações contidas neste website não devem ser consideradas como
                            oferta de venda de cotas de fundos de investimentos ou de qualquer
                            título ou valor mobiliário, recomendação de investimento e nem
                            deve servir como única base para tomada de decisões de
                            investimento. Fundos de investimentos não contam com a garantia do
                            administrador do fundo, do gestor da carteira, de qualquer
                            mecanismo de seguro ou, ainda, do Fundo Garantidor de Créditos -
                            FGC. A rentabilidade obtida no passado não representa garantia de
                            rentabilidade futura. A rentabilidade divulgada não é líquida de
                            impostos. Ao investidor é recomendada a leitura cuidadosa do
                            prospecto e do regulamento do fundo de investimento ao aplicar os
                            seus recursos. O Fundo Pandhora não se responsabiliza pela
                            publicação acidental de informações incorretas, nem por decisões
                            de investimentos tomadas com base neste material. O conteúdo deste
                            website não pode ser reproduzido sem prévia e expressa
                            autorização. A Pandhora, seus sócios e funcionários não se
                            responsabilizam pelo uso indevido do conteúdo deste website, pela
                            publicação acidental de informações incorretas, nem por decisões
                            de investimentos tomadas com base neste material. SUPERVISÃO E
                            FISCALIZAÇÃO: Comissão de Valores Mobiliários – CVM. Serviço de
                            Atendimento ao Cidadão em www.cvm.gov.br
                        </p>
                    </div>
                    <div className="Page__footerCopyright text-center">
                        <p>Pandhora Investimentos LTDA - Todos os direitos reservados</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Page;